const ControlLibraryType = {
  SET_LIBRARIES: 'SET_LIBRARIES',
  APPEND_LIBRARIES: 'APPEND_LIBRARIES',
  SET_LIBRARIES_TOTAL: 'SET_LIBRARIES_TOTAL',
  SET_SELECTED_LIBRARY: 'SET_SELECTED_LIBRARY',
  SET_CARDS: 'SET_CARDS',
  SET_CARDS_TOTAL: 'SET_CARDS_TOTAL',
  SET_LOADING: 'SET_LOADING',
  SET_CARDS_LOADING: 'SET_CARDS_LOADING',
} as const;

export default ControlLibraryType;
